export default "<div [cert]=\"cert\" [mb]=\"false\"></div>\n"